export default __webpack_public_path__ + "static/media/s.956a1081.jpg";